import { createFileRoute } from '@tanstack/react-router';

type Search = {
  view?: 'list' | 'grid';
  sort?: 'name--asc' | 'name--desc' | 'last_used_at--asc' | 'last_used_at--desc';
  locationId?: string;
  templateId?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/forms/templates')({
  validateSearch: (search: Search): Search => {
    return {
      view: search.view,
      sort: search.sort,
      locationId: search.locationId,
      templateId: search.templateId,
    };
  },
});
